export default __webpack_public_path__ + "static/media/featured1.4def6799.png";